// ── MakeOfferModal.jsx ────────────────────────────────────────────────────────
// Sub-modal: make an offer on a product

import React from 'react';
import styles from '../ProductDetailModal.module.css';

const MakeOfferModal = ({
  product,
  offerAmount,
  setOfferAmount,
  offerMessage,
  setOfferMessage,
  offerError,
  isSubmittingOffer,
  onSubmit,
  onClose,
}) => {
  return (
    <div
      className={styles.offerModalOverlay}
      onClick={() => !isSubmittingOffer && onClose()}
    >
      <div className={styles.offerModal} onClick={(e) => e.stopPropagation()}>
        <button
          className={styles.offerCloseBtn}
          onClick={onClose}
          disabled={isSubmittingOffer}
        >
          ×
        </button>

        <h3>Make an Offer</h3>
        <p className={styles.offerModalSubtitle}>
          Current price: <strong>KES {product.price.toLocaleString()}</strong>
        </p>

        {offerError && <div className={styles.errorBanner}>{offerError}</div>}

        <div className={styles.offerInputGroup}>
          <label>Your Offer Amount (KES)</label>
          <input
            type="number"
            className={styles.offerInput}
            placeholder="Enter amount"
            value={offerAmount}
            onChange={(e) => setOfferAmount(e.target.value)}
            min="0"
            disabled={isSubmittingOffer}
          />
        </div>

        <div className={styles.offerInputGroup}>
          <label>Message (Optional)</label>
          <textarea
            className={styles.offerTextarea}
            placeholder="Add a message to the seller..."
            value={offerMessage}
            onChange={(e) => setOfferMessage(e.target.value)}
            rows="3"
            disabled={isSubmittingOffer}
          />
          <small style={{ color: '#9ca3af', fontSize: '11px' }}>
            {offerMessage.length}/500 characters
          </small>
        </div>

        <div className={styles.offerModalButtons}>
          <button
            className={styles.offerSubmitBtn}
            onClick={onSubmit}
            disabled={isSubmittingOffer}
          >
            {isSubmittingOffer ? 'Submitting...' : 'Submit Offer'}
          </button>
          <button
            className={styles.offerCancelBtn}
            onClick={onClose}
            disabled={isSubmittingOffer}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default MakeOfferModal;
